import * as React from 'react';

import { IconButton } from '@coursera/cds-core';
import type { IconButtonProps } from '@coursera/cds-core';

/**
 * Simple wrapper around CDS IconButton to provide Coach-specific styles.
 * Note: this should not be used outside of the parent `<CoachStylesProvider/>
 * which was built in static/bundles/cds-labs/components/Coach/CoachStylesProvider.tsx`
 */
export const CoachIconButton = (props: IconButtonProps): React.ReactElement => {
  return <IconButton className="coach-icon-button" {...props} />;
};

export const CoachIconButtonSmall = (props: IconButtonProps): React.ReactElement => {
  return <IconButton className="coach-icon-button" variant="ghost" size="small" {...props} />;
};

export default { CoachIconButton, CoachIconButtonSmall };
